import React from 'react'

const Event = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M4.50176 5.29688H6.50176M5.50176 4.29688V6.29688M12.0018 4.29688L11.5018 6.29688M18.5018 5.29688H20.5018M19.5018 4.29688V6.29688M15.5018 9.29688L14.5018 10.2969M18.5018 13.2969L20.5018 12.7969M18.5018 19.2969H20.5018M19.5018 18.2969V20.2969M14.5018 16.8149L7.98376 10.2969L3.59376 19.8769C3.50699 20.0629 3.47955 20.2711 3.51518 20.4732C3.5508 20.6753 3.64776 20.8616 3.79289 21.0067C3.93802 21.1519 4.1243 21.2488 4.32643 21.2845C4.52856 21.3201 4.73676 21.2926 4.92276 21.2059L14.5018 16.8149Z"
      stroke={color}
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export default Event
